<template>
  <main
    ref="mainRef"
    class="d-flex flex-column gr-4"
    :class="isMobile ? 'px-4 gr-10' : 'gr-4'"
  >
    <template v-if="selectedTeamMember">
      <v-btn
        class="align-self-start"
        color="primary"
        text
        @click="handleClickBack"
      >
        <span class="ui-icon-arrow-back mr-3" />
        {{ t('О проекте', options) }}
      </v-btn>
      <TeamMemberDescriptionCard :team-member="selectedTeamMember" />
      <InfoCard
        :title="t('Достижения', options)"
        :text-html="transDynamic(selectedTeamMember, `description,${language},${needTranslate}`)"
      />
    </template>
    <template v-else>
      <a
        v-if="isSuperUser && !isMobile"
        :href="reverseFull({ name: 'admin:info_inforawhtml_change', args: [infoId] })"
        class="adminka d-block pa-2"
        target="_blank"
        rel="noopener noreferrer"
      >{{ t('править', options) }}</a>

      <InfoCard
        :is="index === 0 ? FirstInfoCard : InfoCard"
        v-for="(infoRecord, index) in infoRecords"
        :key="`info-card-${infoRecord.id}`"
        :adminka-url="isSuperUser && !isMobile
          ? reverseFull({ name: 'admin:info_inforawhtmlrecord_change', args: [infoRecord.id] })
          : undefined"
        :title="transDynamic(infoRecord, `name,${language},${needTranslate}`)"
        :text-html="transDynamic(infoRecord, `html_code,${language},${needTranslate}`)"
        :class="{ 'mx-n4': isMobile && index === 0 }"
        truncated
      />

      <InfoCard
        v-if="teamMembers.length"
        ref="teamMembersRef"
        :title="t('Наша команда', options)"
      >
        <div class="d-flex flex-wrap gr-6 gc-4 justify-space-between">
          <a
            v-if="isEditorUser && !isMobile"
            :href="`${reverseFull({ name: 'admin:info_teammember_add' })}?sites=<${siteName}>`"
            class="adminka"
            target="_blank"
            rel="noopener noreferrer"
          >{{ t('Добавить нового члена команды', options) }}</a>

          <template v-if="isMobile">
            <TeamMemberCardMobile
              v-for="teamMember in teamMembers"
              :key="`team-member-${teamMember.id}`"
              :team-member="teamMember"
            />
          </template>
          <template v-else>
            <TeamMemberCard
              v-for="teamMember in teamMembers"
              :key="`team-member-${teamMember.id}`"
              :adminka-url="isEditorUser && !isMobile
                ? reverseFull({ name: 'admin:info_teammember_change', args: [teamMember.id] })
                : undefined"
              :team-member="teamMember"
              @click="handleClickTeamMember(teamMember)"
            />
          </template>
        </div>
      </InfoCard>
    </template>
  </main>
</template>

<script lang="ts" setup>
import { ref, nextTick, computed } from 'vue'
import I18NextVue from 'i18next'
import transDynamic from 'djanjucks/filters/transDynamic'
import { useContextStore, useURLStore } from 'src/store'
import type { ContextStore, InfoRecord, TeamMember } from 'src/components/pages/info/about-us/index/types'
import FirstInfoCard from 'src/components/pages/info/about-us/index/components/MainContent/components/FirstInfoCard.vue'
import InfoCard from 'src/components/pages/info/about-us/index/components/MainContent/components/InfoCard.vue'
import TeamMemberCard from 'src/components/pages/info/about-us/index/components/MainContent/components/TeamMemberCard.vue'
import TeamMemberCardMobile from 'src/components/pages/info/about-us/index/components/MainContent/components/TeamMemberCardMobile.vue'
import TeamMemberDescriptionCard from 'src/components/pages/info/about-us/index/components/MainContent/components/TeamMemberDescriptionCard.vue'

const { context }: ContextStore = useContextStore()

const { t, language } = I18NextVue
const options = { ns: language }
const needTranslate = context.feature_flags.pd_l10n_footer_pages

defineProps<{
  siteName: string
  infoRecords: InfoRecord[]
  infoId: number
  teamMembers: TeamMember[]
  isSuperUser: boolean
  isEditorUser: boolean
}>()

const isMobile = computed(() => context?.flavour === 'mobile')

const { reverseFull } = useURLStore()
const selectedTeamMember = ref<TeamMember | null>(null)

const mainRef = ref()
const teamMembersRef = ref()

async function handleClickTeamMember(teamMember: TeamMember) {
  selectedTeamMember.value = teamMember
  await nextTick()
  mainRef.value?.scrollIntoView({
    block: 'start',
  })
}

async function handleClickBack() {
  selectedTeamMember.value = null

  await nextTick()
  teamMembersRef.value?.$el.scrollIntoView({
    block: 'start',
  })
}
</script>
